function findFirstMonthWithCellContent(panel) {
    const months = panel.querySelectorAll('.calendar-mobile-month');
    if (months.length === 0) return null;

    const now = new Date();
    const currentMonthIndex = now.getMonth(); // 0–11

    let firstFutureMonth = null;

    for (let index = 0; index < months.length; index++) {
        const month = months[index];

        if (index < currentMonthIndex) continue;

        if (!firstFutureMonth) {
            firstFutureMonth = month;
        }

        const cellContent = month.querySelector('.calendar-grid__cell-content .acf-innerblocks-container');
        if (cellContent && cellContent.innerHTML.trim() !== '') {
            return month;
        }
    }

    return firstFutureMonth;
}



function initCalendarBlock() {
    const blocks = document.querySelectorAll(".calendar-block");

    blocks.forEach((block) => {
        const navContainer = block.querySelector(".calendar-block__nav");
        const hiddenNavs = block.querySelectorAll(".calendar-block__nav-item-wrapper");
        const panels = block.querySelectorAll(".calendar-block__tab-panel");

        hiddenNavs.forEach(wrapper => {
            const btn = wrapper.querySelector(".calendar-block__nav-item");
            if (btn) navContainer.appendChild(btn);
            wrapper.remove();
        });

        const navButtons = block.querySelectorAll(".calendar-block__nav-item");

        function hideAllPanels() {
            panels.forEach((panel) => {
                panel.style.display = "none";
                const mobileMonths = panel.querySelectorAll('.calendar-mobile-month');
                mobileMonths.forEach(month => month.classList.remove('active'));
            });
            navButtons.forEach((btn) => btn.classList.remove("is-active"));
        }

        navButtons.forEach((button) => {
            button.addEventListener("click", () => {
                const targetId = button.getAttribute("data-tab");
                const targetPanel = block.querySelector(`#${targetId}`);
                hideAllPanels();
                button.classList.add("is-active");
                if (targetPanel) {
                    targetPanel.style.display = "block";
                    setupMobileSelect(targetPanel);
                }
                block.dataset.activeTab = targetId;
            });
        });

        const lastActiveTab = block.dataset.activeTab;
        if (lastActiveTab) {
            const lastButton = block.querySelector(`.calendar-block__nav-item[data-tab="${lastActiveTab}"]`);
            lastButton?.click();
        } else if (navButtons.length > 0) {
            navButtons[0].click();
        } else if (panels.length > 0) {
            setupMobileSelect(panels[0]);
        }

    });
}

function isMobile() {
    return window.innerWidth <= 789;
}

let isCurrentlyMobile = isMobile();

function setupMobileSelect(panel) {
    if (!isMobile()) return;

    const months = panel.querySelectorAll('.calendar-mobile-month');
    if (months.length === 0) return;

    let customSelect = panel.querySelector('.calendar-mobile-custom-select');

    if (customSelect) {
        months.forEach(m => m.classList.remove('active'));
        const items = panel.querySelectorAll('.calendar-mobile-select-item');
        items.forEach(i => i.classList.remove('active'));

        const activeMonth = months[0];
        activeMonth.classList.add('active');
        const button = customSelect.querySelector('.calendar-mobile-select-button');
        const firstItem = panel.querySelector('.calendar-mobile-select-item');
        if (button && firstItem) button.textContent = firstItem.textContent;
        firstItem?.classList.add('active');

        return;
    }

    if (!customSelect) {
        const label = document.createElement('label');
        label.textContent = 'Wybierz miesiąc';
        label.className = 'calendar-mobile-label';

        customSelect = document.createElement('div');
        customSelect.className = 'calendar-mobile-custom-select';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'calendar-mobile-select-button';
        button.textContent = 'Wybierz miesiąc';
        customSelect.appendChild(button);

        const dropdown = document.createElement('div');
        dropdown.className = 'calendar-mobile-select-dropdown';
        dropdown.style.display = 'none';

        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'calendar-mobile-select-close';
        closeButton.textContent = ' ';
        closeButton.addEventListener('click', () => {
            dropdown.style.display = 'none';
        });
        dropdown.appendChild(closeButton);

        let activeMonth = panel.querySelector('.calendar-mobile-month.active');

        if (!activeMonth) {
            const monthWithContent = findFirstMonthWithCellContent(panel);
            if (monthWithContent) {
                activeMonth = monthWithContent;
            } else {
                activeMonth = months[0];
            }
            activeMonth.classList.add('active');
        }

        months.forEach((month, index) => {
            const item = document.createElement('div');
            item.className = 'calendar-mobile-select-item';
            item.textContent = month.querySelector('h4')?.textContent || `Month ${index + 1}`;
            item.dataset.month = month.getAttribute('data-month') || index;

            if (month === activeMonth) {
                item.classList.add('active');
                button.textContent = item.textContent;
            }

            item.addEventListener('click', () => {
                months.forEach(m => m.classList.remove('active'));
                const items = panel.querySelectorAll('.calendar-mobile-select-item');
                items.forEach(i => i.classList.remove('active'));

                month.classList.add('active');
                item.classList.add('active');

                button.textContent = item.textContent;
                dropdown.style.display = 'none';
            });

            dropdown.appendChild(item);
        });

        customSelect.appendChild(dropdown);

        button.addEventListener('click', () => {
            dropdown.style.display = dropdown.style.display === 'none' ? 'flex' : 'none';
        });

        panel.insertBefore(label, panel.firstChild);
        panel.insertBefore(customSelect, label.nextSibling);
    }
}

window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        const mobile = isMobile();
        if (mobile && !isCurrentlyMobile) {
            document.querySelectorAll('.calendar-block__tab-panel').forEach(panel => {
                setupMobileSelect(panel);
            });
        }
        isCurrentlyMobile = mobile;
    }, 250);
});

document.addEventListener("DOMContentLoaded", () => {
    initCalendarBlock();
});

if (typeof acf !== 'undefined') {
    acf.addAction('ready', (el) => {
        initCalendarBlock(el);
    });
    acf.addAction('append', (el) => {
        initCalendarBlock(el);
    });
}
